import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, or } from 'ember-truth-helpers';
import GeneralCountryFlag from 'lumen/components/general/country-flag';
import type { Event, Holiday } from 'lumen/models';

interface GeneralTooltipsTooltipEventsSignature {
  Args: {
    events?: Event[];
    holidays: Holiday[];
    mergeCountryFlags?: boolean;
    title?: string;
  };
}

const GeneralTooltipsTooltipEvents = <template>
  {{#if (or @events.length @holidays.length)}}
    <div
      class="tooltip-section tooltip-section--width-auto event-section text-200--regular"
    >
      <table cellpadding="0" cellspacing="0">
        {{#if @title}}
          <thead>
            <th>{{t @title}}</th>
          </thead>
        {{/if}}
        <tbody>
          {{#unless @title}}
            {{! This row is introduced to switch the alternating row colors.
                When no title is available, we want to start with a white row. }}
            <tr class="invisible-table-row"></tr>
          {{/unless}}
          {{#each @holidays as |holiday|}}
            <tr>
              <td class="flex items-center gap-100 truncate">
                {{holiday.name}}
                {{#if (and @mergeCountryFlags holiday.hasMoreThanTwoCountries)}}
                  <PrismIcon @name="events-global" @size="small" />
                {{else}}
                  {{#each holiday.countries as |country|}}
                    <GeneralCountryFlag @countryCode={{country}} />
                  {{/each}}
                {{/if}}
              </td>
            </tr>
          {{/each}}
          {{#each @events as |event|}}
            <tr class="tooltip-event-row">
              <td class="truncate">
                {{#if event.isCancelled}}
                  <span class="cancelled-event">
                    {{event.displayName}}
                  </span>
                {{else}}
                  {{event.displayName}}
                {{/if}}
                <br />
                <span class="secondary-event-info">
                  {{event.formattedDays}}
                  {{if event.location " - "}}
                  {{event.location}}
                  {{if event.visitors " - "}}
                  {{event.visitorsFormatted}}
                  {{#if event.visitors}}
                    {{t "ranking.visitors"}}
                  {{/if}}
                </span>
              </td>
            </tr>
          {{/each}}
        </tbody>
      </table>
    </div>
  {{/if}}
</template> satisfies TOC<GeneralTooltipsTooltipEventsSignature>;

export default GeneralTooltipsTooltipEvents;
